// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HouseholdLoading_StateFragment = { __typename?: 'KGLoadingState', householdID: string, isLoading: boolean, sessions: Array<{ __typename?: 'KGLoadingSession', id: string, status: Types.KgLoadingStatus, startedAt: Time, documents: Array<{ __typename?: 'KGLoadingDocument', documentID: string, revision: number, discoveredNodeCount: number, discoveredRelationshipCount: number, nodes: Array<{ __typename?: 'KGLoadingNode', id: string, name: string, kind: string }>, relationships: Array<{ __typename?: 'KGLoadingRelationship', id: string, sourceID: string, targetID: string, kind: string }> }> }> };

export type HouseholdKgLoadingQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type HouseholdKgLoadingQuery = { __typename?: 'Query', kgLoadingState: (
    { __typename?: 'KGLoadingState' }
    & HouseholdLoading_StateFragment
  ) };

export type HouseholdKgLoadingUpdatedSubscriptionVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type HouseholdKgLoadingUpdatedSubscription = { __typename?: 'Subscription', kgLoadingStateUpdated: (
    { __typename?: 'KGLoadingState' }
    & HouseholdLoading_StateFragment
  ) };

export const Operations = {
  Query: {
    HouseholdKGLoading: 'HouseholdKGLoading' as const
  },
  Subscription: {
    HouseholdKGLoadingUpdated: 'HouseholdKGLoadingUpdated' as const
  },
  Fragment: {
    HouseholdLoading_State: 'HouseholdLoading_State' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const HouseholdLoading_StateFragmentDoc = gql`
    fragment HouseholdLoading_State on KGLoadingState {
  householdID
  isLoading
  sessions {
    id
    status
    startedAt
    documents {
      documentID
      revision
      discoveredNodeCount
      discoveredRelationshipCount
      nodes {
        id
        name
        kind
      }
      relationships {
        id
        sourceID
        targetID
        kind
      }
    }
  }
}
    `;
export const HouseholdKgLoadingDocument = gql`
    query HouseholdKGLoading($householdID: ID!) {
  kgLoadingState(householdID: $householdID) {
    ...HouseholdLoading_State
  }
}
    ${HouseholdLoading_StateFragmentDoc}`;

/**
 * __useHouseholdKgLoadingQuery__
 *
 * To run a query within a React component, call `useHouseholdKgLoadingQuery` and pass it any options that fit your needs.
 * When your component renders, `useHouseholdKgLoadingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHouseholdKgLoadingQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useHouseholdKgLoadingQuery(baseOptions: Apollo.QueryHookOptions<HouseholdKgLoadingQuery, HouseholdKgLoadingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HouseholdKgLoadingQuery, HouseholdKgLoadingQueryVariables>(HouseholdKgLoadingDocument, withFetchPolicyContext(options));
      }
export function useHouseholdKgLoadingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HouseholdKgLoadingQuery, HouseholdKgLoadingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HouseholdKgLoadingQuery, HouseholdKgLoadingQueryVariables>(HouseholdKgLoadingDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useHouseholdKgLoadingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HouseholdKgLoadingQuery, HouseholdKgLoadingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HouseholdKgLoadingQuery, HouseholdKgLoadingQueryVariables>(HouseholdKgLoadingDocument, withFetchPolicyContext(options));
        }
export type HouseholdKgLoadingQueryHookResult = ReturnType<typeof useHouseholdKgLoadingQuery>;
export type HouseholdKgLoadingLazyQueryHookResult = ReturnType<typeof useHouseholdKgLoadingLazyQuery>;
export type HouseholdKgLoadingSuspenseQueryHookResult = ReturnType<typeof useHouseholdKgLoadingSuspenseQuery>;
export type HouseholdKgLoadingQueryResult = Apollo.QueryResult<HouseholdKgLoadingQuery, HouseholdKgLoadingQueryVariables>;
export const HouseholdKgLoadingUpdatedDocument = gql`
    subscription HouseholdKGLoadingUpdated($householdID: ID!) {
  kgLoadingStateUpdated(householdID: $householdID) {
    ...HouseholdLoading_State
  }
}
    ${HouseholdLoading_StateFragmentDoc}`;

/**
 * __useHouseholdKgLoadingUpdatedSubscription__
 *
 * To run a query within a React component, call `useHouseholdKgLoadingUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHouseholdKgLoadingUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHouseholdKgLoadingUpdatedSubscription({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useHouseholdKgLoadingUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<HouseholdKgLoadingUpdatedSubscription, HouseholdKgLoadingUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HouseholdKgLoadingUpdatedSubscription, HouseholdKgLoadingUpdatedSubscriptionVariables>(HouseholdKgLoadingUpdatedDocument, withSubscriptionIgnoreResults(options));
      }
export type HouseholdKgLoadingUpdatedSubscriptionHookResult = ReturnType<typeof useHouseholdKgLoadingUpdatedSubscription>;
export type HouseholdKgLoadingUpdatedSubscriptionResult = Apollo.SubscriptionResult<HouseholdKgLoadingUpdatedSubscription>;